(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name commons.directive:setAutoDate
     * @restrict EA
     * @element
     *
     * @description
     *
     * @example
     <example module="commons">
     <file name="index.html">
     <set-auto-date></set-auto-date>
     </file>
     </example>
     *
     */
    angular
        .module('commons')
        .directive('setAutoDate', setAutoDate);

    function setAutoDate(CommonLogicService, $timeout) {
        return {
            restrict: 'A',
            require: '^?ngModel',
            replace: false,
            link: function (scope, element, attrs, ctrl) {
                /* jshint unused:false */
                /* eslint "no-unused-vars": [2, {"args": "none"}] */
                element.on('blur', function () {
                    CommonLogicService.checkDate(this);
                    $timeout(function(){
                        if(ctrl){
                            ctrl.$setViewValue(element[0].value);
                        }else{
                            scope.selectedDate = element[0].value;
                        }
                        scope.$apply();
                    });

                });

            }
        };
    }
}());
